module.exports = __webpack_public_path__ + "media/images/landing/second/photo19-ca9065a8f1fe15c098c40aa4cbc33d8b.jpg";